import { Amplify } from 'aws-amplify';
import amplifyconfig from '../aws-export.js';

function trimStr(v) {
    return typeof v === 'string' ? v.trim() : '';
}

/** Cognito region prefix in pool id, e.g. us-west-1_fjww… → us-west-1 */
function regionFromUserPoolId(poolId) {
    const i = poolId.indexOf('_');
    return i > 0 ? poolId.slice(0, i) : '';
}

const Init = () => {
    const envBucket = trimStr(import.meta.env.VITE_REACT_APP_S3_BUCKET);
    const envIdentityPoolId = trimStr(import.meta.env.VITE_REACT_APP_IDENTITY_POOL_ID);
    const envUserPoolId = trimStr(import.meta.env.VITE_COGNITO_USER_POOL_ID);
    const envUserPoolWebClientId = trimStr(
        import.meta.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID
    );

    const useCognitoEnvOverride = Boolean(envUserPoolId && envUserPoolWebClientId);
    const cognitoRegionOverride = useCognitoEnvOverride
        ? regionFromUserPoolId(envUserPoolId)
        : '';

    const cognitoRegion =
        cognitoRegionOverride ||
        amplifyconfig.aws_cognito_region ||
        amplifyconfig.aws_project_region ||
        '';
    const envIdentityRegion =
        envIdentityPoolId && envIdentityPoolId.includes(':')
            ? envIdentityPoolId.split(':')[0]
            : '';
    // Identity pool region must match the configured User Pool region.
    const useEnvIdentityPool = Boolean(
        envIdentityPoolId && envIdentityRegion && envIdentityRegion === cognitoRegion
    );

    Amplify.configure({
        ...amplifyconfig,
        ...(envBucket ? { aws_user_files_s3_bucket: envBucket } : {}),
        aws_user_files_s3_bucket_region:
            amplifyconfig.aws_user_files_s3_bucket_region ||
            amplifyconfig.aws_project_region,
        ...(useEnvIdentityPool ? { aws_cognito_identity_pool_id: envIdentityPoolId } : {}),
        ...(useCognitoEnvOverride && cognitoRegionOverride
            ? {
                  aws_user_pools_id: envUserPoolId,
                  aws_user_pools_web_client_id: envUserPoolWebClientId,
                  aws_cognito_region: cognitoRegionOverride,
              }
            : {}),
    });
};

/**
 * @return {import('public/apiGateway-js-sdk/apigClient.js').apigClientFactory}
 */
 
// const ApiGateway = apigClientFactory?.newClient({
//     apiKey: "ICNExLiUwH3c9AxGYXQXy73x34iiUWRC14qPJNYz"
// });

export {
    // ApiGateway
}

export default Init;